<template>
  <div class="age-verification">
    <p v-if="description" class="mb-3 text-muted">{{ description }}</p>

    <div class="mb-3">
      <FlatInput
        id="dobInput"
        label="Date of birth"
        type="date"
        v-model="dob"
        :onEnter="submit"
      />
    </div>

    <div class="d-flex align-items-center gap-2">
      <AppButton
        type="button"
        :disabled="submitting || !dob"
        :loading="submitting"
        @buttonClick="submit"
        ignore-plan-restriction
      >
        Submit
      </AppButton>
      <span v-if="minAge" class="text-muted small">Minimum required age: {{ minAge }}</span>
    </div>

    <p v-if="error" class="text-danger mt-2">{{ error }}</p>
  </div>
</template>

<script>
import FlatInput from '@/Components/FlatInput.vue';
import AppButton from '@/Components/AppButton.vue';

export default {
  name: 'AgeVerification',
  components: { FlatInput, AppButton },
  props: {
    linkId: { type: Number, required: true },
    minAge: { type: [Number, String], default: null },
    description: { type: String, default: '' }
  },
  data() {
    return {
      dob: '',
      error: '',
      submitting: false
    };
  },
  emits: ['success', 'failure'],
  methods: {
    async submit() {
      this.error = '';
      if (!this.dob) {
        this.error = 'Please enter your date of birth.';
        return;
      }

      try {
        this.submitting = true;
        const input = this.dob;

        const url = typeof route === 'function' && route().has('link.unlock')
          ? route('link.unlock')
          : '/link/unlock';

        const res = await axios.post(url, {
          link_id: this.linkId,
          step: 2,
          input
        });

        const ok = !!(res && res.data && res.data.success === true);
        if (ok) {
          this.$emit('success', true);
        } else {
          this.error = 'Sorry, you do not meet the minimum age requirement.';
          this.$emit('failure');
        }
      } catch (e) {
        this.error = 'Unable to verify age at the moment. Please try again.';
        this.$emit('failure');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.age-verification {
  padding: 4px;
}
</style>
